
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import locationImg from "../../assets/locationIconFilled.png";
import React, { useEffect, useState } from "react";
import {ZoomEvents} from "./Map"
const customIcon = new L.Icon({
  iconUrl: locationImg,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

function ChangeView({ locations }) {
  const map = useMap();
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    if (locations && locations.length > 0 && isFirstLoad) {
      const bounds = L.latLngBounds(
        locations.map((location) => location.position)
      );
      map.fitBounds(bounds, { padding: [50, 50] });
      setIsFirstLoad(false);
    }
  }, [locations, map, isFirstLoad]);

  return null;
}


const FullscreenMap = ({locations, setFullScreenModal}) => {
  const [center, setCenter] = useState([56.130366, -106.346771]);

  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <button
        onClick={() => setFullScreenModal(false)}
        title="Exit FullScreen"
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          zIndex: 1000,
          background: "var(--primary-bg)",
          border: "none",
          border: "1px solid #ccc",
          cursor: "pointer",
          padding: "8px 12px",
          borderRadius: "4px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        }}
      >
        <i className="bi bi-fullscreen-exit"></i>
      </button>

      <MapContainer
        center={center}
        style={{ height: "100vh", width: "100vw", padding:"0px" }}
        zoom={15}
        scrollWheelZoom={true}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <ChangeView locations={locations} />
        <ZoomEvents/>
        {locations.map((location) => (
          <Marker
            key={location.id}
            position={location.position}
            icon={customIcon}   
          >
            <Popup>
              <div className="popup-content">
                <img
                  src={location.image || "/placeholder.svg"}
                  alt={location.name}
                  className="img-fluid mb-2"
                  loading="lazy"
                />
                <h5 className="font-bold mb-1">{location.name}</h5>
                <p className="popup-address mb-2">{location.address}</p>
                <div className="mb-2 popup-timing">
                  <p className="time">Hours:</p>
                  <p className="">
                    <strong>{location.weekdaysname}</strong>
                    {location.weekdays}
                  </p>
                  <p className="">
                    <strong>{location.weekendname}</strong> {location.weekend}
                  </p>
                  <p className="">
                    <strong>{location.sundayname}</strong>
                    {location.sunday}
                  </p>
                </div>
                <p className="popup-phone">
                  <strong>Phone:</strong> {location.phone}
                </p>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default FullscreenMap;
